import React from "react";

interface ECSLoaderProps {
    show?: boolean;
}

// Overlay loader for a card/section (parent should be `relative`)
const ECSLoader: React.FC<ECSLoaderProps> = ({ show = true }) => {
    if (!show) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            className="absolute inset-0 z-50 flex items-center justify-center bg-white/60 backdrop-blur-[3px] rounded-[inherit]"
        >
            <div className="flex items-center gap-3 rounded-2xl bg-white px-4 py-3 shadow-pop">
                <span className="relative w-5 h-5">
                    <span className="absolute inset-0 rounded-full border-2 border-slate-200" />
                    <span className="absolute inset-0 rounded-full border-2 border-transparent border-t-brand-main animate-spin" />
                </span>
                <span className="text-[13px] font-medium text-slate-600">Loading…</span>
            </div>
        </div>
    );
};

export default ECSLoader;
